// Limbex: los links a otros dominios abren en una pestaña nueva, sin pasar referrer ni acceso a la ventana.
// También cubre los links que se agregan después (carrusel, carrito, apps).
(function () {
  function mark(link) {
    if (!link.href || link.hostname === window.location.hostname) return;
    if (!/^https?:$/.test(link.protocol)) return;
    link.target = '_blank';
    link.rel = 'noreferrer noopener';
  }

  function scan(root) {
    if (root.tagName === 'A') mark(root);
    if (root.querySelectorAll) root.querySelectorAll('a[href]').forEach(mark);
  }

  scan(document);
  new MutationObserver(function (records) {
    records.forEach(function (record) {
      record.addedNodes.forEach(scan);
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
